$(document).ready(function(){
    let select = $('.cabinet-select__wrap'),
        // options = $('.cabinet-select__options'),
        option = $('.cabinet-select__option');

    select.click(function(e) {
        e.preventDefault();
        select.toggleClass('active');
        $(document).on('click', function(e){
            
            if (!select.is(e.target) && select.has(e.target).length === 0) {
                select.removeClass('active');
            }
        });
    })
    option.on('click', function(e){
        e.preventDefault();
        let optionId = $(this).data('id')
        option.removeClass('active')
        $(this).closest('.cabinet-select__wrap').addClass('selected')
        $(this).addClass('active')
        $(this).closest('.cabinet-select__wrap').find('.cabinet-select__selected').html($(this).text())
        $(this).closest('.cabinet-select__wrap').find("input").val(optionId)
    })
})